import React, { Component } from 'react';
import './index.css';

import { useNavigate } from "react-router-dom";
import { useAuth } from 'fennec-ui';

 // or 'antd/dist/antd.less'
import locale from 'antd/es/date-picker/locale/ru_RU';
import {
  Form,
  Input,
  Select,
  Button,
  message,
  Card,
  Alert
} from 'antd';

export default function EmailVerification(props) {
  let navigate = useNavigate();
  const auth = useAuth();
  const formRef = React.createRef();

  const [error, setError] = React.useState({ error: false, message: "" })
  const [success, setSuccess] = React.useState(false)

  React.useEffect(() => {
    var nurl = new URL(window.location.href);
    var token = nurl.searchParams.get("token");
    auth.fetch('/api/email-verification-token?token=' + token).then(res => {
      if (!res || !res.status) {
        setError({ error: true, message: res.message })
      } else if (res && res.status) {
        setSuccess(true);
      }
    });
  }, [])


  return (
    <div style={{
      height: "calc(100vh - 12px)",
      backgroundColor: (props.mobile) ? "white" : "#f5f5f5",
      margin: "5px",
      borderRadius: "5px"
    }}>

      <div className="register-form" style={{ paddingBottom: "0px", textAlign: "center", maxWidth: (props.mobile) ? "300px" : "600px" }}>
        <a href={auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href)}>
          <img style={{ height: "70px" }} src="/resources/logo-blue.svg" alt="Logo" />
        </a>
      </div>

      {success && <div className="register-form">
        <Card>
          <Alert
            message="Адрес электронной почты успешно подтвержден"
            type="success"
            showIcon
          />
          <div style={{ paddingTop: "25px" }}>
            <a href="/">Вернуться на сайт</a>
          </div>
        </Card>
      </div>}
      {error.error && <div className="register-form">
        <Card>
          <Alert
            message="Ошибка!"
            description={error.message}
            type="error"
            showIcon
          />
          <div style={{ paddingTop: "25px" }}>
            <a href="/">Вернуться на сайт</a>
          </div>
        </Card>
      </div>}
    </div>
  );
}